<template>
    <div>
        <b-card no-body v-for="(cat, index) in categories" :key="index">
            <b-card-header
                class="p-1"
                header-tag="header"
                data-toggle="collapse"
                v-b-toggle="`collapse-cat${cat.category}`"
            >
                <span>
                    {{ cat.label.toUpperCase() }}
                </span>
                <div class="float-right">
                    <em class="fa iconCollapseExpand"></em>
                </div>
            </b-card-header>
            <b-collapse
                :id="`collapse-cat${cat.category}`"
                :accordion="isAccordion()"
                v-model="cat.expanded"
                :visible="cat.category === 1"
                @show="$emit('onCategoryShow', cat.category)"
            >
                <b-card-body>
                    <b-container>
                        <b-row
                            v-for="(field, index) in getCategory(cat.category)"
                            :key="index"
                        >
                            <b-col>
                                <label
                                    :for="`${id}Input_${cat.category}_${index}`"
                                    class="style-label-md"
                                    >{{ field.label }}</label
                                >
                            </b-col>
                            <b-col>
                                <x-select
                                    v-if="field.domain"
                                    :id="`${id}Select_${cat.category}_${index}`"
                                    :name="`${id}Select_${cat.category}_${index}`"
                                    v-model="field.value"
                                    :options="field.domain.keyvalues"
                                    :showDefaultOption="true"
                                    :simpleMode="true"
                                    :disabled="fieldDisabled(cat)"
                                />
                                <x-number
                                    v-else-if="
                                        field.type === FIELD_TYPE.NUMERIC
                                    "
                                    :id="`${id}Input_${cat.category}_${index}`"
                                    :name="`${id}Input_${cat.category}_${index}`"
                                    v-model="field.value"
                                    :state="field.state"
                                    :pattern="field.pattern"
                                    :maxLength="field.maxlength"
                                    @input="$emit('onInput', field)"
                                    :invalidMessage="
                                        invalidFieldValueErrorMessage
                                    "
                                    :disabled="fieldDisabled(cat)"
                                    :placeholder="field.placeholder"
                                />
                                <x-input
                                    v-else
                                    :id="`${id}Input_${cat.category}_${index}`"
                                    :name="`${id}Input_${cat.category}_${index}`"
                                    v-model="field.value"
                                    :state="field.state"
                                    :title="field.title"
                                    :justInvalidState="true"
                                    :pattern="field.pattern"
                                    :maxlength="field.maxlength"
                                    :minlength="field.minlength"
                                    @input="$emit('onInput', field)"
                                    @change="$emit('onChange', field)"
                                    :invalidMessage="
                                        invalidFieldValueErrorMessage
                                    "
                                    :disabled="fieldDisabled(cat)"
                                    :placeholder="field.placeholder"
                                />
                                <div v-if="field.info" class="fieldInfo mb-2">
                                    {{ field.info }}
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
    import { FIELD_TYPE } from '../../../constants';
    export default {
        props: {
            id: { type: String, required: true },
            categories: { type: Array, required: true },
            accordion: { type: Boolean, required: false, default: false },
            inputFields: { type: Array, required: true },
            invalidFieldValueErrorMessage: { type: String, required: false }
        },
        data() {
            return { FIELD_TYPE: FIELD_TYPE };
        },
        methods: {
            getCategory(category) {
                return this.inputFields?.filter(
                    (field) =>
                        field.category === category ||
                        (Array.isArray(field.category) &&
                            field.category.includes(category))
                );
            },

            isAccordion() {
                return this.accordion ? 'useaccordion' : '';
            },

            /*
             * Disable field if the category it belongs to is not expanded.
             */
            fieldDisabled(category) {
                return !category.expanded;
            }
        }
    };
</script>

<style scoped lang="scss">
.card {
    border: 0px;

    & .card-header {
        font-weight: bold;
        background-color: rgba(0, 0, 0, 0);
        border-bottom: 0px;
    }

    & .card-body {
        padding: 0.75rem;
        padding-bottom: 0;

        & .container {
            padding-left: 0px;
            padding-right: 0px;
            overflow-wrap: initial;
        }

        & .fieldInfo {
            font-size: 75%;
            margin-top: -1rem;
        }
    }
}
</style>
